import _ from 'lodash'

// 属性路径
const pathCallback = 'callback';
const pathCallbackGet = [pathCallback, 'getter'].join('.');
const pathCallbackSet = [pathCallback, 'setter'].join('.');
const pathCallbackSave = [pathCallback, 'save'].join('.');
const pathCallbackCheck = [pathCallback, 'check'].join('.');


export default {
  callbackGet: getterBuilder(pathCallbackGet, _.identity), // 编辑页面的访问器 getter 预处理 函数
  callbackSet: getterBuilder(pathCallbackSet, _.identity), // 编辑页面的访问器 setter 预处理 函数
  callbackSave: getterBuilder(pathCallbackSave, _.identity), // 编辑页面的 保存前的 预处理 函数
  callbackCheck: getterBuilder(pathCallbackCheck, _.constant(true)), // 编辑页面的 保存前的 检查 函数
}

/**
 * 返回属性的访问函数
 * @param {String} path 属性的路径
 * @param {any} defaultValue 当无法访问到属性的时候的默认值
 */
function getterBuilder(path, defaultValue) {
  return function (item) {
    return _.get(item, path, defaultValue);
  }
}